export default {
  columnsOrder: [
    'id',
    'channel',
    'customer',
    'pressId',
    'type',
    'email',
    'qtyWarranty',
    'qtyPending',
    'qtyAdjusted',
    'insertionDate',
    'adjustmentMonth',
  ],
  showFilters: true,
  sortBy: {
    column: 'id',
    type: 'Desc',
  },
  visibleColumns: [
    'id',
    'channel',
    'customer',
    'pressId',
    'type',
    'email',
    'qtyWarranty',
    'qtyPending',
    'qtyAdjusted',
    'insertionDate',
    'adjustmentMonth',
  ],
  widths: {},
};
